export default "__VITE_ASSET__DsH8Mpw2__"